import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppComponent } from './app.component';
import { BurialsSearchFilterPipe } from './pipes/burials-search-filter.pipe';
import { LoginComponent } from './components/login/login/login.component';
import { DashComponent } from './components/dash/dash/dash.component';
import { BurialsComponent } from './components/dash/burials/burials.component';
import { CremationComponent } from './components/dash/cremation/cremation.component';
import { PartneredComponent } from './components/dash/partnered/partnered.component';
import { TipsComponent } from './components/dash/tips/tips.component';
import { ApplicationComponent } from './components/dash/burials/application/application.component';
import { AttachmentsComponent } from './components/dash/burials/attachments/attachments.component';
import { DatesComponent } from './components/dash/burials/dates/dates.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { Dokumente2026Component } from './components/dokumente2026/dokumente2026.component';
import { SafeBaseUrlPipe } from './pipes/safe-base-url.pipe';
import { LongReadableDatePipe } from './pipes/long-readable-date.pipe';
import { BurialsSearchTextPipe } from './pipes/burials-search-text.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { BurialHeaderComponent } from './components/dash/burials/burial-header/burial-header.component';
import { BurialFilterComponent } from './components/dash/burials/burial-filter/burial-filter.component';
import { ErrorNotificationComponent } from './components/shared/error-notification/error-notification.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    BurialsSearchFilterPipe,
    LoginComponent,
    DashComponent,
    BurialsComponent,
    CremationComponent,
    PartneredComponent,
    TipsComponent,
    ApplicationComponent,
    AttachmentsComponent,
    DatesComponent,
    DocumentsComponent,
    Dokumente2026Component,
    SafeBaseUrlPipe,
    LongReadableDatePipe,
    BurialsSearchTextPipe,
    DateFormatPipe,
    BurialHeaderComponent,
    BurialFilterComponent,
    ErrorNotificationComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
